module.exports = __webpack_public_path__ + "img/HGUC.94f9c1c0.jpg";